import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCreateEmojisKey } from '../../utils/keys';
export const useCreateImages = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const createEmojisKey = getCreateEmojisKey();
    return useMutation((input) => client.media.uploadImages(input, useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError), {
        mutationKey: createEmojisKey,
        ...useMutationOptions,
        onError: useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError,
    });
};
//# sourceMappingURL=useCreateImages.js.map